import { map } from 'lodash'

import { API, MOCK_DATA } from '@/constants'
import { axiosServer as axios } from '@/base/axios'

import { WPPageData } from '@/types'

export const resolveGravityFieldsFromFormId = async (section: any) => {
  const {
    data: { fields, button }
  } = await axios.get(`${API.GRAVITY_FORM}/${section.form.form_id}/`)

  return {
    ...section,
    form: {
      ...section.form,
      submit: button.text,
      fields
    }
  }
}

export const parseSection = (section: any) => {
  return {
    acf_fc_layout: section.acf_fc_layout,
    ...section[section.acf_fc_layout]
  }
}

export const mapPageStaticProps = async ({ acf, ...pageData }: WPPageData) => {
  return {
    ...pageData,
    acf: {
      ...acf,
      builder: await Promise.all(
        map(acf?.builder, async (section: any) => parseSection(section))
      )
    }
  }
}

export const mapOptionsDataProps = async (optionsData: any) => {
  const { form_id } = optionsData.newsletter

  const {
    data: { fields, button }
  } = MOCK_DATA
      ? { data: require(`@/data/forms/${form_id}.json`) }
      : await axios.get(`${API.GRAVITY_FORM}/${form_id}/`)

  return {
    ...optionsData,
    newsletter: {
      ...optionsData.newsletter,
      submit: button.text,
      fields
    }
  }
}
